"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

function _createSuper(Derived) {
  return function () {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var CopyrightLabel = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(CopyrightLabel, _React$PureComponent);

  var _super = _createSuper(CopyrightLabel);

  function CopyrightLabel() {
    (0, _classCallCheck2["default"])(this, CopyrightLabel);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(CopyrightLabel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          year = _this$props.year,
          company = _this$props.company,
          phrase = _this$props.phrase;
      return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("span", {
        role: "img",
        "aria-label": "Copyright"
      }, "\xA9"), /*#__PURE__*/_react["default"].createElement("span", null, year || (0, _moment["default"])().format('YYYY'), ' ', company, ' ', phrase));
    }
  }]);
  return CopyrightLabel;
}(_react["default"].PureComponent);

exports["default"] = CopyrightLabel;
CopyrightLabel.propTypes = {
  company: _propTypes["default"].string,
  phrase: _propTypes["default"].string,
  year: _propTypes["default"].number
};
CopyrightLabel.defaultProps = {
  company: '',
  phrase: '',
  year: null
};
CopyrightLabel.propOptions = {};
CopyrightLabel.dataPropsMap = {
  company: ['business', 'name']
};